import { FC } from 'react';

import CCBuyNow from 'components/credit-card-buy-now';
import ElectronicBuyNow from 'components/electronic-buy-now';
import { useAppSelector } from 'hooks';
import { chosenPaymentMethodKey, sortedPaymentMethodList } from 'modules/payment-methods';
import { AchDetails, CreditCard } from 'types/payment-method';
import { PAYMENT_METHODS_TYPES } from 'utils/constants';

const PaymentMethodType = {
  CreditCard: 'Credit Card',
  AdyenCreditCard: 'Adyen Credit Card',
  AdyenACH: 'Adyen ACH',
  Electronic: 'Electronic',
};

const BuyNow: FC = (): JSX.Element => {
  const selectedSortedPaymentMethodList = useAppSelector(sortedPaymentMethodList);
  const selectedChosenPaymentMethodKey = useAppSelector(chosenPaymentMethodKey);

  const paymentDetails = selectedSortedPaymentMethodList.find(
    (paymentMethod) => paymentMethod.paymentMethodKey === selectedChosenPaymentMethodKey,
  )!;

  let paymentMethodType = PaymentMethodType.Electronic;
  if (paymentDetails.paymentMethodType === PAYMENT_METHODS_TYPES.cc) {
    paymentMethodType = (paymentDetails as CreditCard).isAdyen
      ? PaymentMethodType.AdyenCreditCard
      : PaymentMethodType.CreditCard;
  } else if (paymentDetails.paymentMethodType === PAYMENT_METHODS_TYPES.ach) {
    paymentMethodType = (paymentDetails as AchDetails).isAdyen
      ? PaymentMethodType.AdyenACH
      : PaymentMethodType.Electronic;
  }

  return (
    <>
      {
        {
          [PaymentMethodType.CreditCard]: <CCBuyNow currentCreditCard={paymentDetails as CreditCard} />,
          [PaymentMethodType.AdyenCreditCard]: <></>,
          [PaymentMethodType.AdyenACH]: <></>,
          [PaymentMethodType.Electronic]: (
            <ElectronicBuyNow
              paymentMethodKey={paymentDetails.paymentMethodKey}
              paymentType={paymentDetails.paymentMethodType}
            />
          ),
        }[paymentMethodType]
      }
    </>
  );
};

export default BuyNow;
